// Auto color palette for video categories. Admin can override per-category
// via `video_categories.color`. Falls back to a deterministic palette slot
// based on display_order so colors remain stable across renders.
export const CATEGORY_COLOR_PALETTE = [
  "#3B82F6", // blue
  "#0EA5E9", // sky
  "#06B6D4", // cyan
  "#14B8A6", // teal
  "#10B981", // emerald
  "#22C55E", // green
  "#84CC16", // lime
  "#EAB308", // yellow
  "#F59E0B", // amber
  "#F97316", // orange
  "#EF4444", // red
  "#F43F5E", // rose
  "#EC4899", // pink
  "#D946EF", // fuchsia
  "#A855F7", // purple
  "#8B5CF6", // violet
  "#6366F1", // indigo
  "#2563EB", // strong blue
  "#0F3460", // brand navy
  "#B45309", // brown
  "#7C3AED", // deep violet
  "#059669", // deep emerald
  "#DC2626", // deep red
  "#64748B", // slate
] as const;

export function getCategoryColor(
  cat: { color?: string | null; display_order?: number | null } | null | undefined,
  fallbackIndex = 0,
): string {
  if (cat?.color) return cat.color;
  const idx = (cat?.display_order ?? fallbackIndex + 1) - 1;
  return CATEGORY_COLOR_PALETTE[((idx % CATEGORY_COLOR_PALETTE.length) + CATEGORY_COLOR_PALETTE.length) % CATEGORY_COLOR_PALETTE.length];
}

// Returns readable text color (black/white) for a given hex background.
export function readableTextOn(hex: string): string {
  const h = hex.replace("#", "");
  if (h.length !== 6) return "#ffffff";
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const luma = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luma > 0.6 ? "#0f172a" : "#ffffff";
}
